import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('LiftMarket crash:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          background: 'var(--bg)',
          color: 'var(--on-surface)',
          fontFamily: 'var(--font-body)',
        }}>
          <div style={{
            maxWidth: 480,
            textAlign: 'center',
            padding: '48px 32px',
            background: 'var(--surface-container)',
            border: '1px solid var(--outline-var)',
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-lg)',
          }}>
            <div style={{
              fontSize: 48,
              color: 'var(--primary)',
              marginBottom: 16,
              fontFamily: 'var(--font-head)',
              fontWeight: 700,
            }}>!</div>
            <h1 style={{
              fontFamily: 'var(--font-head)',
              fontSize: 22,
              fontWeight: 700,
              letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              marginBottom: 12,
            }}>Something went wrong</h1>
            <p style={{
              fontSize: 14,
              color: 'var(--on-surface-var)',
              lineHeight: 1.6,
              marginBottom: 24,
            }}>
              An unexpected error crashed the page. Please reload to continue.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
              style={{ padding: '12px 24px' }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
